import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: '/control',
    name: 'Control',
    component: () => import('@/views/Control.vue'),
  },
  // Support 页面：不依赖设备连接，断连/被抢占也可访问
  {
    path: '/support',
    name: 'Support',
    component: () => import('@/views/support/Support.vue'),
  },
  {
    path: '/support/faq',
    name: 'Faq',
    component: () => import('@/views/support/Faq.vue'),
  },
  {
    path: '/support/contact',
    name: 'Contact',
    component: () => import('@/views/support/Contact.vue'),
  },
  {
    path: '/support/manual',
    name: 'Manual',
    component: () => import('@/views/support/Manual.vue'),
  },
  {
    path: '/support/feedback',
    name: 'Feedback',
    component: () => import('@/views/support/Feedback.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

/**
 * 发版兜底：部署新版本后旧的带 hash 的 chunk 会被删除，而网关对不存在的
 * /assets/*.js 走 SPA 回退返回 index.html（200 + text/html），浏览器按
 * 模块 MIME 严格校验直接拒绝 → 懒加载路由（FAQ 等）加载失败。
 * 此时整页刷新一次即可拿到新 index.html 和新 chunk。
 * 用 sessionStorage 时间戳防止新版本仍失败时无限刷新循环。
 */
const CHUNK_RELOAD_KEY = 'adm.web.chunkReloadAt'
router.onError((error, to) => {
  const msg = String((error as Error)?.message || error || '')
  const isChunkLoadError =
    /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|MIME type/i.test(
      msg,
    )
  if (!isChunkLoadError) return
  let lastReloadAt = 0
  try {
    lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0)
  } catch {
    /* 隐私模式等禁用 storage：仍然允许刷新一次 */
  }
  if (Date.now() - lastReloadAt < 10_000) {
    console.error('[router] 路由 chunk 连续加载失败，停止自动刷新:', msg)
    return
  }
  try {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
  } catch {
    /* ignore */
  }
  console.warn('[router] 路由 chunk 加载失败（疑似发版后旧资源失效），整页刷新:', msg)
  window.location.assign(to.fullPath)
})

export default router
